import styled from "styled-components";
import Text from "../Text";
import { portalColors } from "../BusinessPortalComponents";

export const SubText = styled(Text)`
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: ${ p => p.weight || 400 };
    text-align: ${p => p.align || "left"};
    color: ${ p => p.color || portalColors.text };
    font-size: ${p => p.size || "20px"};
    margin: ${ p => p.margin || 0 };
`;
/* HEADER */
export const RowHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    margin-bottom: 20px;
  
`;

export const CountText = styled.div`
    font: normal normal 500 ${p => p.size || "14px"}/${p => p.lineHeight || "16px"} Manrope;
    color: ${portalColors.text};
`;
/* GRID */
export const DocumentGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
    margin-top: 12px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 20px;
    }
`;

export const DocumentItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const DocumentTitle = styled.div`
    font: normal normal 500 14px/16px Manrope;
    color: ${portalColors.text};
`;

/* CARD */
export const DocumentCard = styled.div`
    padding: 8px;
    background: ${portalColors.surface};
    box-shadow: 0px 5px 10px #0000001A;
    border: 1px solid ${portalColors.border};
    border-radius: 15px;

    display: flex;
    flex-direction: column;
`;

/* UPLOAD BUTTON */
export const UploadButton = styled.div`
    width: 126px;
    height: 40px;
    background: ${portalColors.blue};
    box-shadow: 0px 5px 10px #0000001A;
    border: 1px solid #E0E0E0;
    border-radius: 12px;

    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const UploadText = styled.span`
    font: normal normal 500 14px/16px Manrope;
    color: var(--calendar-bg, #FFFFFF);
    display: flex;
    align-items: center;
`;

export const UploadIcon = styled.img`
    margin-top: 4px;
    width: 42px;
    height: 42px;
`;

/* FILE DISPLAY */
export const FileRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 3px;
    color: ${portalColors.mutedText};
    height: 40px;
`;

export const FileName = styled.div`
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
`;

/* ACTIONS */
export const ActionRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const ViewButton = styled.button`
    width: 67px;
    height: 32px;
    background: ${portalColors.blue};
    opacity: 1;

    color: var(--calendar-bg, #fff);
    border-radius: 7px;
    box-shadow: 0px 3px 6px #00000029;
    border: none;
    cursor: pointer;
    font-size: 12px;
`;

export const IconBtn = styled.div`
    width: 26px;
    height: 26px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: ${portalColors.blue};
    border-radius: 50%;
    cursor: pointer;

    img {
        width: 18px;
        height: 18px;
        object-fit: contain;
    }
`;

/* REMOVE BUTTON (UPDATED STYLE AS YOU REQUESTED) */
export const RemoveButton = styled.button`
    text-align: center;
    font: normal normal 500 14px/16px Manrope;
    letter-spacing: 0px;
    color: #FF3B3B;
    cursor: pointer;
    width: 147px;
    height: 39px;
    border-radius: 10px;
    background: #FFF5F5 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #FF3B3B;
    opacity: 1;
`;

/* MODAL */
export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ModalBox = styled.div`
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    width: 600px;
    height: 600px;
    background: ${portalColors.surface};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;

export const ModalClose = styled.div`
    position: absolute;
    right: 10px;
    top: 5px;
    font-size: 22px;
    cursor: pointer;
`;

export const RadioWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    flex-shrink: 0;
    cursor: pointer;
`;

export const ConfirmText = styled.div`
    text-align: center;
    font: normal normal bold 14px/22px Manrope;
    letter-spacing: 0px;
    color: #9B9B9B;
    text-transform: capitalize;
    opacity: 1;
    margin-right: -13px;
`;

export const RadioCircle = styled.div`
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid #9B9B9B;
    background: ${portalColors.surface};
    box-sizing: border-box;
`;

export const RadioCheckIcon = styled.img`
    width: 26px;
    height: 26px;
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

// REMOVE MODAL
export const RemoveModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
`;

export const RemoveModalBox = styled.div`
    width: 760px;
    max-width: 90vw;
    min-height: 380px;
    background: ${portalColors.surface};
    box-shadow: 0px 5px 5px #00000014;
    border: 1px solid ${portalColors.border};
    border-radius: 6px;
    padding: 20px 50px;
    display: flex;
    flex-direction: column;
`;

export const ModalTitle = styled.h2`
    text-align: left;
    font: normal normal bold 40px/24px Manrope;
    letter-spacing: 0px;
    color: ${portalColors.text};
    opacity: 1;
`;

export const ModalDesc = styled.p`
    text-align: left;
    font: normal normal normal 14px/16px Manrope;
    letter-spacing: 0px;
    color: ${portalColors.text};
    opacity: 1;
    margin-top: -10px;
`;

export const ModalFooter = styled.div`
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
`;

export const CancelButton = styled.button`
    width: 140px;
    height: 38px;
    background: ${portalColors.surface};
    border: 1px solid ${portalColors.borderStrong};
    color: ${portalColors.text};
    border-radius: 7px;
    box-shadow: 0px 3px 6px #00000029;
    cursor: pointer;
`;

export const ConfirmButton = styled.button`
    width: 140px;
    height: 38px;
    background: ${portalColors.blue};
    border: none;
    border-radius: 7px;
    box-shadow: 0px 3px 6px #00000029;
    color: var(--calendar-bg, #fff);
    cursor: pointer;
`;

export const ModalDocumentCard = styled.div`
    width: 345px;
    height: 56px;
    background: ${portalColors.surface};
    box-shadow: 0px 5px 10px #0000001A;
    border: 1px solid ${portalColors.border};
    border-radius: 15px;
    opacity: 1;
    margin-top: 10px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
`;

export const FooterContainer = styled.div`
    margin-top: auto;
    display: flex;
    flex-direction: column;
`;

export const Hr = styled.div`
    height: 1px;
    background: #ddd;
    margin: 20px 0;
    width: calc(100% + 100px);
    margin-left: -50px;
`;

export const SmallLoader = styled.div`
    width: 40px;
    height: 40px;
    margin-top: -22px;

    display: flex;
    align-items: center;
    justify-content: center;

    svg, div {
        width: 40px !important;
        height: 40px !important;
    }
`;

export const PreviewImage = styled.img`
    max-width: 100%;
    max-height: 90vh;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
    margin: auto;
`;

export const UploadedByText = styled.div`
    text-align: left;
    font: normal normal normal 14px/22px Manrope;
    letter-spacing: 0px;
    color: ${portalColors.text};
    margin-top: -5px;
`;
